import angular, {
  IAttributes,
  ICompileService,
  IDirective,
  ITemplateLinkingFunction,
} from "angular";
import { IContractType } from "../../../shared/ContractService";
import { kebabCase } from "lodash";

export const vsDirectiveName = "contractDetail";

const contractTypeAttributeName = "contractType";
const contractTypeAttributeKebabName = kebabCase(contractTypeAttributeName);
const contractAttributeName = "contract";

const linkingFunctions: { [name: string]: ITemplateLinkingFunction } = {};

contractDetailDirectiveFactory.$inject = ["$compile"];
export function contractDetailDirectiveFactory(
  $compile: ICompileService
): IDirective {
  return {
    link: {
      pre: (s, element, attrs, ctrl, transclude) => {
        const contractType = s.$eval(attrs[contractTypeAttributeName]);

        if (!contractType) {
          throw new Error("Couldn't match type");
        }

        const linkingFunction = getLinkingFunction(contractType, attrs);

        const detailElementInstance = linkingFunction(s.$new(), () => {});

        element.append(detailElementInstance);
      },
    },
  };

  function getLinkingFunction(contractType: IContractType, attrs: IAttributes) {
    if (Object.keys(linkingFunctions).find((n) => n === contractType.id)) {
      return linkingFunctions[contractType.id];
    }

    const kebabComponentName = kebabCase(contractType.detailComponentName);

    const detailElement = angular.element(
      `<${kebabComponentName}></${kebabComponentName}>`
    );

    detailElement.attr(contractAttributeName, attrs[contractAttributeName]);
    detailElement.attr(
      contractTypeAttributeKebabName,
      attrs[contractTypeAttributeName]
    );

    return (linkingFunctions[contractType.id] = $compile(detailElement));
  }
}
